import React  from 'react';
import './loadingPage.scss';





function LoadingPage() {
  return (
    <div className="cssloader">
      <div className="sh1"></div>
      <div className="sh2"></div>
    </div>
  )
}

export default LoadingPage;